import { render } from "./ParametrosColombia.vue?vue&type=template&id=049de858&scoped=true"
import script from "./ParametrosColombia.vue?vue&type=script&lang=js"
export * from "./ParametrosColombia.vue?vue&type=script&lang=js"

import "./ParametrosColombia.css?vue&type=style&index=0&id=049de858&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049de858"]])

export default __exports__